export default {
    SET_LIST_FOLDER_RECEIVE_MAIL(state,payload){
        let result = []
        result = payload
        state.listFolderReceiveMail = result;
    },
    SET_LIST_RULE_RECEIVE_MAIL(state,payload){
        let result = []
        result = payload
        state.listRuleReceiveMail = result;
    }
}